import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Layout.css';
import Login from './Login';
import { supabase } from '../supabaseClient';

const HomeIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'block' }}>
    <path d="M3 12L12 4l9 8" />
    <path d="M9 21V13h6v8" />
    <path d="M21 21H3" />
  </svg>
);

const HamburgerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);

const Layout = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [user, setUser] = useState(null);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => setUser(data?.user || null));
    const { data: listener } = supabase.auth.onAuthStateChange((_, session) => {
      setUser(session?.user || null);
    });
    return () => listener?.subscription.unsubscribe();
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    if (!isMenuOpen) return;
    function handleClickOutside(event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setShowLogin(false);
  };

  return (
    <div className="layout">
      <header style={{ padding: '1rem', background: '#222', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        <Link to="/" style={{ position: 'absolute', left: 24, top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <HomeIcon />
        </Link>
        {/* Key icon for login/logout */}
        <button
          style={{ position: 'absolute', right: 24, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, zIndex: 10, transition: 'right 0.2s', display: 'flex', alignItems: 'center' }}
          onClick={() => setShowLogin(true)}
          title={user ? user.email : 'Log ind'}
        >
          <img src="/key.png" alt="Log ind" style={{ width: 26, height: 26, display: 'block', filter: 'invert(1) brightness(2)' }} />
          {user && (
            <svg width="16" height="16" viewBox="0 0 16 16" style={{ marginLeft: 4, marginTop: 2 }}>
              <circle cx="8" cy="8" r="8" fill="#3ec46d" />
              <path d="M5 8.5l2 2 4-4" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round" />
            </svg>
          )}
        </button>
        <style>{`
          @media (max-width: 700px) {
            .layout header button[title] {
              right: 60px !important;
            }
          }
        `}</style>
        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          <Link to="/regler" style={{ color: '#fff', textDecoration: 'none', fontWeight: 500, fontSize: '1.2rem' }}>Regler</Link>
          <Link to="/remedier" style={{ color: '#fff', textDecoration: 'none', fontWeight: 500, fontSize: '1.2rem' }}>Remedier</Link>
          <Link to="/praktik" style={{ color: '#fff', textDecoration: 'none', fontWeight: 500, fontSize: '1.2rem' }}>Praktik</Link>
          <Link to="/hall-of-fame" style={{ color: '#fff', textDecoration: 'none', fontWeight: 500, fontSize: '1.2rem' }}>Hall of Fame</Link>
          <Link to="/galleri" style={{ color: '#fff', textDecoration: 'none', fontWeight: 500, fontSize: '1.2rem' }}>Galleri</Link>
        </nav>
        {/* Mobile Hamburger Menu */}
        <button 
          onClick={toggleMenu}
          className="mobile-menu-button"
          ref={buttonRef}
        >
          <HamburgerIcon />
        </button>
        {/* Mobile Dropdown Menu */}
        {isMenuOpen && (
          <div className="mobile-dropdown" ref={menuRef}>
            <nav className="mobile-nav">
              <Link 
                to="/regler" 
                onClick={closeMenu}
              >
                Regler
              </Link>
              <Link 
                to="/remedier" 
                onClick={closeMenu}
              >
                Remedier
              </Link>
              <Link 
                to="/praktik" 
                onClick={closeMenu}
              >
                Praktik
              </Link>
              <Link 
                to="/hall-of-fame" 
                onClick={closeMenu}
              >
                Hall of Fame
              </Link>
              <Link 
                to="/galleri" 
                onClick={closeMenu}
              >
                Galleri
              </Link>
            </nav>
          </div>
        )}
        {/* Login modal */}
        {showLogin && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.35)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setShowLogin(false)}>
            <div style={{ minWidth: 320, maxWidth: 420, background: '#fff', borderRadius: 12, boxShadow: '0 2px 16px #0002', padding: 0, position: 'relative' }} onClick={e => e.stopPropagation()}>
              {user ? (
                <div style={{ padding: 24, textAlign: 'center' }}>
                  <div style={{ marginBottom: 16, color: '#333', fontWeight: 600 }}>Du er logget ind som<br /><span style={{ color: '#3a6ea5' }}>{user.email}</span></div>
                  <button onClick={handleLogout} style={{ background: '#e63946', color: '#fff', border: 'none', borderRadius: 8, padding: '0.7em 2em', fontWeight: 600, fontSize: 16, cursor: 'pointer' }}>Log ud</button>
                </div>
              ) : (
                <Login onLogin={u => { setUser(u); setShowLogin(false); }} />
              )}
              <button onClick={() => setShowLogin(false)} style={{ position: 'absolute', top: 8, right: 8, background: 'none', border: 'none', fontSize: 22, color: '#888', cursor: 'pointer' }} title="Luk">×</button>
            </div>
          </div>
        )}
      </header>
      <main style={{ minHeight: '80vh', padding: '2rem' }}>{children}</main>
      <footer style={{ padding: '1rem', background: '#222', color: '#fff', textAlign: 'center', fontStyle: 'italic' }}>
        © All rights to play and distribute LOL Disc Golf is owned by the fellowship of Gerlev + Morten Lund
      </footer>
    </div>
  );
};

export default Layout; 